__turbopack_context__.v({
  "attributesContainer": "styles-module__W7u9xW__attributesContainer",
  "attributesSkeleton": "styles-module__W7u9xW__attributesSkeleton",
  "brandName": "styles-module__W7u9xW__brandName",
  "hoverImage": "styles-module__W7u9xW__hoverImage",
  "listItem": "styles-module__W7u9xW__listItem",
  "productGrid": "styles-module__W7u9xW__productGrid",
  "seeMoreText": "styles-module__W7u9xW__seeMoreText",
  "translucentHoverOverlay": "styles-module__W7u9xW__translucentHoverOverlay",
});
